import { UserAdminGrantedEvent } from '@rematter/frontend-lib-api-client/grpc/core/v1/user_events_pb';
import { Col } from '@rematter/ui-web';
import { FieldDisplay, IDField } from '@rematter/ui-web';

type UserAdminGrantedDetailProps = {
  event: UserAdminGrantedEvent;
};

export const UserAdminGrantedDetail = ({
  event,
}: UserAdminGrantedDetailProps) => {
  const user = event.user;

  if (!user) {
    return (
      <Col className="@UserAdminGrantedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@UserAdminGrantedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          User Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={user.id?.value} />
          <FieldDisplay label="Email" value={user.email} />
          <FieldDisplay
            label="Name"
            value={`${user.firstName} ${user.lastName}`}
          />
        </div>
      </Col>

      <Col
        className="rounded-md border border-success/20 bg-success/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-success/80">
          Admin Privileges Granted
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField
            label="Organization ID"
            value={event.organizationId?.value}
          />
        </div>
      </Col>
    </Col>
  );
};
